<template>
  <div>
      <input
          class="checkbox"
          type="checkbox"
          :checked="checked"
          @change="onChange"
      />
<!--      <a target="_blank" :href="'https://innotech.atlassian.net/browse/' + label"><label> {{label}}</label></a>-->
    <a @click="onClick" ><label class="clickable">{{label}}</label></a>
    </div>
</template>

<script>
export default {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: Boolean,
    label: String
  },
  methods: {
    onChange(event) {
      this.$emit('change', event.target.checked)
    },
    onClick(){
      this.$emit('click', this.label)
    }
  }
}
</script>

<style>
  .checkbox {
    height: 20px;
    width: 20px;
    margin-right: 12px;
  }
  .clickable {
    cursor: pointer;
    text-decoration: underline;
    color: blue;
  }
</style>